import { CollectionListResponseItemType } from "@sellar-io/api-v2/types";
import dayjs from "dayjs";
import { ReactElement } from "react";
import { ListElement } from "../../components";
import { BadgeGreen, BadgeRed, BadgeAmber } from "../../components/badge/Badge";
import { COLLECTION_DETAILS } from "../../constants/routes";
import { useParamAsNumber } from "../../hooks/useParamAsNumber";
import { imageUrls, H5, H6 } from "@sellar-io/components";

export default function CollectionListItem({
  collection,
}: {
  collection: CollectionListResponseItemType;
}): ReactElement {
  const collectionId = useParamAsNumber(
    COLLECTION_DETAILS,
    "collectionId",
    false,
  );

  const status = () => {
    switch (collection.status) {
      case "active":
        return <BadgeGreen icon={"CHECK_CIRCLE"}>Active</BadgeGreen>;
      case "cancelled":
        return <BadgeRed icon={"CLOSE"}>Cancelled</BadgeRed>;
      case "draft":
        return <BadgeAmber icon={"TIMER_SAND_EMPTY"}>Draft</BadgeAmber>;
    }
  };

  const fulfillmentType = collection.fulfillmentType;
  const imageURl =
    fulfillmentType === "apc" ? imageUrls.apcLogo : imageUrls.upsLogo;

  return (
    <ListElement
      promptText={""}
      to={COLLECTION_DETAILS.href({ collectionId: collection.id })}
      selected={collectionId === collection.id}
    >
      <img
        alt={fulfillmentType}
        src={imageURl}
        className={"h-[48px] w-[48px]"}
      />
      <div className={"space-y-2"}>
        <div className="flex flex-col">
          <H5>{dayjs(collection.collectionDate).format("dddd DD MMMM")}</H5>
          <H6>
            Collecting between: {collection.earliestCollectionTime} -{" "}
            {collection.latestCollectionTime}
          </H6>
        </div>
        <div>
          <div className={"flex flex-wrap gap-2"}>{status()}</div>
        </div>
      </div>
    </ListElement>
  );
}
